exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Ilu18s7XT5nBFdjKC0p10 .error{color:dycolor-internal(!error-text,@theme-white);background-color:dycolor-internal(!error-background,@theme-error);border-color:dycolor-internal(!error-border,@theme-error)}\n", ""]);

// exports
exports.locals = {
	"root": "_1Ilu18s7XT5nBFdjKC0p10"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/gotu-vue-common/src/components/creative-refresh/CreativeRefresh.scss
// module id = 908
// module chunks = 1